<template>
  <!-- <f7-page class=""> -->
  <div class="page">
    <!--bottom-toolbar></bottom-toolbar-->
    <div class="page-content">
      <page-nav-bar currentServiceName="MoneyRoad" subNavTitle="Application Settings" :returnPreviousPage="false"></page-nav-bar>
      <div class="layoutTop"/>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6 offset-md-3">
            <div class="panel21 panel-default">

              <div class="panel-heading">
                  <h4 class="content-block labelAccordionForm">
                      <img src="../../assets/static/images/icons/gearwheels.png" class="formIcon"/>
                      SETTING
                  </h4>
              </div>

              <ul>
                <div class="accordion-item accordionForm">
                  <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                    <div class="item-inner" v-bind:class="colorBottomButton">
                      <div class="form-group row justify-content-start">
                          <div class="item-title createInvoiceBand col-sm-auto">
                            GENERAL
                            <i class="f7-icons formChevron">chevron_right</i>
                          </div>
                      </div>
                    </div>
                  </a>

                  <div class="accordion-item-content">
                    <div class="form-group ">
                      <label class="col-form-label">Generate Bank Transfer Order</label>
                      <label class="label-switch" :class="labelSwitchColorClass">
                        <input type="checkbox" class="checkboxPain001" @change="switchPain001" v-bind:value="pain001">
                        <div class="checkbox"></div>
                      </label>
                    </div>
                    <div class="form-group ">
                      <label class="col-form-label labelCheckbox">Generate Instant Payment</label>
                      <label class="label-switch" :class="labelSwitchColorClass">
                        <input type="checkbox"  class="checkboxPacs008" @change="changeSwitchPacs008" v-bind:value="pacs008">
                        <div class="checkbox"></div>
                      </label>
                    </div>
                    <div class="form-group ">
                      <label class="col-form-label">Send Direct Payment with decision</label>
                      <label class="label-switch" :class="labelSwitchColorClass">
                        <input type="checkbox" class="checkboxDecisionCreancier" @change="changeSwitchDecisionCreancier" v-bind:value="decision_creancier">
                        <div class="checkbox"></div>
                      </label>
                    </div>
                    <div class="form-group ">
                      <label class="col-form-label">{{ $t('settings.activate_OCR') }}</label>
                      <label class="label-switch" :class="labelSwitchColorClass">
                        <input type="checkbox" class="checkboxOcrActivation" @change="changeSwitchOcrActivation" v-bind:value="ocrActivation">
                        <div class="checkbox"></div>
                      </label>
                    </div>
                    <div class="form-group ">
                      <label class="col-form-label">Notify receiver by e-mail</label>
                      <label class="label-switch" :class="labelSwitchColorClass">
                        <input type="checkbox" class="checkboxEmailRcv" @change="switchEmailRcv" v-bind:value="emailForRcv">
                        <div class="checkbox"></div>
                      </label>
                    </div>
                  </div>
                </div>
              </ul>

              <hr>

              <ul>
                <div class="accordion-item accordionForm">
                  <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                    <div class="item-inner" v-bind:class="colorBottomButton">
                      <div class="form-group row justify-content-start">
                          <div class="item-title createInvoiceBand col-sm-auto">
                            OTHER
                            <i class="f7-icons formChevron">chevron_right</i>
                          </div>
                      </div>
                    </div>
                  </a>

                  <div class="accordion-item-content">
                    <div class="form-group">
                      <label class="col-form-label">Always Accept Direct Payments</label>
                      <label class="label-switch" :class="labelSwitchColorClass">
                        <input type="checkbox" class="checkboxAutoAcceptPayment" @change="changeSwitchAutoAcceptPayment" v-bind:value="auto_accept_payment">
                        <div class="checkbox"></div>
                      </label>
                    </div>
                    <div class="form-group">
                      <label class="col-form-label">Highest Amount</label>
                      <div class="" style="text-align: right;">{{max_amount}}</div>
                      <input class="range-slider-streammind" :class="sliderColorClass" type="range" min="0" max="150000" value="0" step="500" v-model="max_amount">
                    </div>
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
          <div class="row">
            <div class="col-md-2 offset-md-7" v-bind:class="colorBottomButton">
                <button round
                class="button-action firstButtonMarginTop"
                @click="changeApplicationSettings">
                  <i class="icon fa fa-save"></i>
                  <span>Save</span>
                </button>
                <div class="toolbarPageBottomBlank"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
  <!-- </f7-page> -->
</template>

<script>
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {errorMessageAlert} from '@/helpers/alert'
// import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      auto_accept_payment: false,
      decision_creancier: false,
      emailForRcv: true,
      idSettingsApplication: '',
      max_amount: 0,
      ocrActivation: false,
      pacs008: false,
      pain001: false
    }
  },
  created () {
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
  },
  mounted () {
    if (!this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.$$('.accordionForm').addClass('accordion-item-expanded')
      this.$$('.formChevron').transform('rotate(90deg)')
    }
    // Init settings
    let dpSettings = this.$engine.settings.directPayments.get()
    this.idSettingsApplication = dpSettings.idSettingsApplication
    this.pacs008 = dpSettings.pacs008 === '1'
    this.decision_creancier = dpSettings.decision_creancier === '1'
    this.max_amount = parseFloat(dpSettings.max_amount)
    this.auto_accept_payment = dpSettings.auto_accept_payment === '1'
    this.pain001 = dpSettings.pain001 === '1'
    this.emailForRcv = dpSettings.emailForRcv === '1'
    this.ocrActivation = dpSettings.ocrActivation === '1'

    // Deal with pain001 and pcs008 checkbox ties
    if (!this.pain001) {
      this.Dom7('.checkboxPacs008').prop('checked', false)
      this.Dom7('.checkboxPacs008').prop('disabled', true)
      this.Dom7('.li_pacs008').hide()
    } else {
      this.Dom7('.checkboxPacs008').prop('disabled', false)
      this.Dom7('.li_pacs008').show()
      if (this.pacs008) {
        this.Dom7('.checkboxPacs008').prop('checked', true)
      }
    }
    if (this.decision_creancier) {
      this.Dom7('.checkboxDecisionCreancier').prop('checked', true)
    }
    if (this.ocrActivation) {
      this.Dom7('.checkboxOcrActivation').prop('checked', true)
    }
    if (this.auto_accept_payment) {
      this.Dom7('.checkboxAutoAcceptPayment').prop('checked', true)
    }
    if (this.pain001) {
      this.Dom7('.checkboxPain001').prop('checked', true)
    }
    if (this.emailForRcv) {
      this.Dom7('.checkboxEmailRcv').prop('checked', true)
    }
  },
  computed: {
    sliderColorClass () {
      let fromIdServiceToSliderClass = {
        '1': 'RTP-slider',
        '2': 'DD-slider',
        '6': 'DP-slider'
      }
      return fromIdServiceToSliderClass[this.$engine.user.currentService.id]
    },
    labelSwitchColorClass () {
      let fromIdServiceToCheckboxClass = {
        '1': 'RTP-label-switch',
        '2': 'DD-label-switch',
        '6': 'DP-label-switch'
      }
      return fromIdServiceToCheckboxClass[this.$engine.user.currentService.id]
    }
  },
  methods: {
    rotateChevron ($event) {
      if (this.Dom7($event.target).parent().parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().hasClass('accordion-item-expanded')) {
        this.Dom7($event.target).find('i').transform('rotate(0deg)')
      } else {
        this.Dom7($event.target).find('i').transform('rotate(90deg)')
      }
    },
    // checkboxPain001 change event
    switchPain001 (obj) {
      this.pain001 = obj.target.checked
      if (this.pain001 === true) {
        this.Dom7('.checkboxPacs008').prop('disabled', false)
        this.Dom7('.labelCheckbox').removeClass('disablecolor')
        this.Dom7('.li_pacs008').show()
      } else {
        this.pacs008 = 'false'
        this.Dom7('.checkboxPacs008').prop('checked', false)
        this.Dom7('.checkboxPacs008').prop('disabled', true)
        this.Dom7('.labelCheckbox').addClass('disablecolor')
        this.Dom7('.li_pacs008').hide()
      }
    },
    // checkboxPacs008 change event
    changeSwitchPacs008 (obj) {
      this.pacs008 = obj.target.checked
    },
    // checkboxEmailRcv change event
    switchEmailRcv (obj) {
      this.emailForRcv = obj.target.checked
    },
    // checkboxDecisionCreancier change event
    changeSwitchDecisionCreancier (obj) {
      this.decision_creancier = obj.target.checked
    },
    changeSwitchOcrActivation (obj) {
      this.ocrActivation = obj.target.checked
    },
    // checkboxAutoAcceptPayment change event
    changeSwitchAutoAcceptPayment (obj) {
      this.auto_accept_payment = obj.target.checked
    },
    // Send settings update query
    changeApplicationSettings () {
      let that = this
      this.paymentsMethod = that.Dom7('input[name=methodRadio]:checked').val()

      this.$engine.settings.directPayments.update({
        pacs008: that.pacs008 === true ? '1' : '0',
        decision_creancier: that.decision_creancier === true ? '1' : '0',
        max_amount: that.max_amount,
        auto_accept_payment: that.auto_accept_payment === true ? '1' : '0',
        pain001: that.pain001 === true ? '1' : '0',
        emailForRcv: that.emailForRcv === true ? '1' : '0',
        ocrActivation: that.ocrActivation === true ? '1' : '0'
      })
      .then(() => {
        that.$f7.modal({
          title: 'Application settings modified',
          text: '<span class="preloader"></span>'
        })
        setTimeout(function () {
          that.$f7.closeModal()
          that.idSettingsApplication = ''
          that.pacs008 = false
          that.decision_creancier = false
          // that.max_amount = 0
          that.auto_accept_payment = false
          that.pain001 = false
          that.emailForRcv = false
          that.ocrActivation = false
          // loadPage(that, {url: '/settings/', force: false, ignoreCache: false})
        }, 2000)
      })
      .catch(err => {
        errorMessageAlert(err, this)
      })
    }
  }
}
</script>
<style scoped>
.subOption {
  font-size: 14px;
}
.disablecolor {
  color: #6d6d72;
}
.subOption input::-webkit-input-placeholder {
  font-size: 14px;
}
.label-switch {
  float: right;
}

ul {
  margin-left: -35px;
}

</style>



// WEBPACK FOOTER //
// CMDirectPaymentsSettingsPage.vue?1ccda1a1